var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-base-application',{attrs:{"title":"営業からの提案状況","beta":""}},[_c('your-sales',{staticClass:"mt-12"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }